<template>
	<div>
		<el-card class="box-card" shadow="never">
			<div slot="header" class="clearfix">
				<span>角色管理</span>
				<el-button v-has="'addRole'" class="createBtn" type="primary" @click="showCreate"><i class="el-icon-plus"></i>新增</el-button>
			</div>
			<div>
				<div class="mr-t15 flex flex-row-between">
					<el-form :inline="true" :model="searchForm" class="demo-form-inline">
						<el-form-item label="角色名稱">
							<el-input v-model="searchForm.keywords" placeholder="請輸入"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="doSearch">搜索</el-button>
						</el-form-item>
						<el-form-item>
							<el-button @click="doReset">重置</el-button>
						</el-form-item>
					</el-form>
				</div>

				<div>
					<el-table v-loading="loading" :border="true" :data="dataList"  style="width: 100%">
						<el-table-column align="center" prop="id" label="序號" width="80">
						</el-table-column>
						<el-table-column align="center" prop="role_name" label="角色名稱">
						</el-table-column>
						<el-table-column align="center" prop="status" label="狀態" width="130">
							<template slot-scope="scope">
								<el-switch @change="statusChange(scope.row)" v-model="scope.row.status" :active-value="1" :inactive-value="0"></el-switch>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="create_at" label="創建時間">
						</el-table-column>
						<el-table-column align="center" label="操作">
							<template slot-scope="scope">
								<div class="flex flex-row-center">
									<div>
										<el-button size="mini" type="primary" v-has="'updateRole'" @click="edit(scope.row)">修改</el-button>
									</div>
									<div class="mr-l15">
										<el-button size="mini" type="danger" v-has="'delRole'" @click="del(scope.row)">删除</el-button>
									</div>
									<div class="mr-l15">
										<el-button size="mini" v-has="'setRoleRule'" @click="set(scope.row)">權限管理</el-button>
									</div>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>

				<div class="mr-t20 flex flex-row-end">
					<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[10,20,40,60,80,100]" :page-size="pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="dataObj.total">
					</el-pagination>
				</div>


				<!-- 新增-->
				<RoleCreateModal @success="createSuccess" :dialogVisible="createDialogVisible" @close="createDialogClose"></RoleCreateModal>

				<!-- 修改 -->
				<RoleEditModal @ok="editOk" ref="editModal" :dialogVisible="editDialogVisible" @close="editDialogClose"></RoleEditModal>

				<!-- 设置 -->
				<RoleSetRuleModal ref="ruleModal" :dialogVisible="setDialogVisible" @close="setDialogClose"></RoleSetRuleModal>
			</div>
		</el-card>
	</div>
</template>

<script>
	import RoleCreateModal from "@/views/settings/role/RoleCreateModal"
	import RoleEditModal from "@/views/settings/role/RoleEditModal"
	import RoleSetRuleModal from "@/views/settings/role/RoleSetRuleModal"
	export default {
		name: "RoleList",
		components: {
			RoleCreateModal,
			RoleEditModal,
			RoleSetRuleModal
		},
		data() {
			return {
				loading:true,
				searchForm: {
					keywords: "",
				},
				currentPage: 1,
				pageSize:10,
				dataList: [],
				dataObj:{},
				createDialogVisible: false,
				editDialogVisible: false,
				setDialogVisible:false,
			}
		},
		created() {
			this.getRoleList();
		},
		methods: {
			// 搜索
			doSearch() {
				this.getRoleList();
			},
			//重置搜索
			doReset() {
				this.resetGetRoleList();
			},
			//切换页码
			handleCurrentChange(e) {
				this.currentPage = e;
				this.getRoleList();
			},
			// 页码大小改变
			handleSizeChange(e) {
				this.getRoleList();
				this.pageSize = e;
			},
			//显示新增dialog
			showCreate() {
				this.createDialogVisible = true;
			},
			//关闭新增dialog
			createDialogClose() {
				this.createDialogVisible = false;
			},
			//传值并且打开修改dialog
			edit(row) {
				this.$refs.editModal.getData(row);
				this.editDialogVisible = true;
			},
			// 传值并且打开权限设置dialog
			set(row){
				this.$refs.ruleModal.getData(row);
				this.setDialogVisible = true;
			},
			//关闭修改dialog
			editDialogClose() {
				this.editDialogVisible = false;
			},
			setDialogClose(){
				this.setDialogVisible = false;
			},
			statusChange(row){
				this.$request({
					url:this.$api.role.updateStatus,
					method:"post",
					data:{
						id:row.id,
						status:row.status
					}
				}).then((res)=>{
					if(res.data.code==1){
						this.$message.success(res.data.msg)
					}else{
						this.$message.error(res.data.msg)
					}
				}).catch(()=>{
					this.$message.error("请求失败");
				})
			},
			createSuccess(){
				this.createDialogVisible = false;
				this.resetGetRoleList();
			},
			editOk(){
				this.editDialogVisible = false;
				this.getRoleList();
			},
			//删除
			del(row) {
				this.$confirm('此操作將永久刪除，是否繼續?', '提示', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$request({
						url:this.$api.role.del,
						method:"post",
						data:{id:row.id}
					}).then((res)=>{
						if(res.data.code==1){
							this.$message.success(res.data.msg);
							this.getRoleList();
						}else{
							this.$message.error(res.data.msg);
						}
					}).catch(()=>{
						this.$message.error("请求失败");
					})
				}).catch(() => {

				});
			},
			//获取角色列表
			getRoleList(){
				this.loading = true;
				this.$request({
					url:this.$api.role.getRoleList,
					data:{
						page:this.currentPage,
						pageSize:this.pageSize,
						keywords:this.searchForm.keywords
					}
				}).then((res)=>{
					this.dataObj = res.data.data;
					this.dataList = res.data.data.data;
					this.loading = false;
				}).catch(()=>{
					this.$message.error("获取列表失败");
				})
			},
			//重置搜索条件查询
			resetGetRoleList(){
				this.searchForm = {
					keywords:""
				}
				this.currentPage = 1;
				this.pageSize = 10;
				this.getRoleList();
			}
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/settings/role/RoleList.vue